module.exports = __webpack_public_path__ + "img/car_00066.d3838e30.jpg";